import { render } from "./FirstTimerSettings.vue?vue&type=template&id=63e31b7c&scoped=true"
import script from "./FirstTimerSettings.vue?vue&type=script&lang=js"
export * from "./FirstTimerSettings.vue?vue&type=script&lang=js"

import "./FirstTimerSettings.vue?vue&type=style&index=0&id=63e31b7c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63e31b7c"]])

export default __exports__